import PropTypes from "prop-types";
import styles from "./IncidentUpcomingEvent.module.css";
import EventCardList from "Security/Shared/EventCardList";

/**
 * Is a list of upcoming case-related events that were created using this tab.
 */

export function IncidentUpcomingEvent({ onClick, eventsArray }) {
  return (
    <>
      <div className={styles.container}>
        <div className={styles.header}>
          <div className={styles.title}>Upcoming</div>
          <button className={styles.button} onClick={onClick}>
            Add Event
          </button>
        </div>

        <div className={styles.cardsContainer}>
          <EventCardList eventsArray={eventsArray} />
        </div>
      </div>
    </>
  );
}

IncidentUpcomingEvent.propTypes = {
  events: PropTypes.arrayOf(PropTypes.object),
  onClick: PropTypes.func,
};
